// extracted by mini-css-extract-plugin
export default {"myWindowContainer":"my-window_myWindowContainer__-y1nQ"};